export default {
  title: 'Analytics',
  cookieExpires: 7,
  useI18n: false,
  baseUrl: {
    // dev: 'http://127.0.0.1:3000/providers',
    dev: 'https://api.medmonk.com/providers',
    pro: 'https://api.medmonk.com/providers',
    patientDev: 'https://api.medmonk.com/patients',
    patientPro: 'https://api.medmonk.com/patients',
  },
  homeName: 'home',
};

export const statuses = [
  {
    color: 'bg-blue-500',
    value: 'medmonk_initiated',
    label: 'Application Received',
  },
  {
    color: 'bg-blue-500',
    value: 'medmonk_submitted',
    label: 'Processing',
  },
  {
    color: 'bg-cyan-500',
    value: 'prescriber_submitted',
    label: 'Missing Patient Consent',
  },
  {
    color: 'bg-stone-600',
    value: 'patient_submitted',
    label: 'Pending Medmonk Approval',
  },
  {
    color: 'bg-red-500',
    value: 'medmonk_rejected',
    label: 'Medmonk Rejected',
  },
  {
    color: 'bg-lime-500',
    value: 'medmonk_approved',
    label: 'Medmonk Approved',
  },
  {
    color: 'bg-green-500',
    value: 'manufacturer_approved',
    label: 'Manufacturer Approved',
  },
  {
    color: 'bg-red-500',
    value: 'manufacturer_rejected',
    label: 'Manufacturer Denied',
  },
  {
    color: 'bg-yellow-500',
    value: 'pharmacy_processing',
    label: 'Pharmacy Processing',
  },
  {
    color: 'bg-purple-500',
    value: 'dispense_scheduled',
    label: 'Dispense Scheduled',
  },
  {
    color: 'bg-green-600',
    value: 'pharmacy_dispensed',
    label: 'Pharmacy Dispensed',
  },
  {
    color: 'bg-zinc-500',
    value: 'cancelled',
    label: 'Request Cancelled',
  },
];

export const stateOptions = [
  { value: 'AL', label: 'Alabama' },
  { value: 'AK', label: 'Alaska' },
  { value: 'AZ', label: 'Arizona' },
  { value: 'AR', label: 'Arkansas' },
  { value: 'CA', label: 'California' },
  { value: 'CO', label: 'Colorado' },
  { value: 'CT', label: 'Connecticut' },
  { value: 'DE', label: 'Delaware' },
  { value: 'FL', label: 'Florida' },
  { value: 'GA', label: 'Georgia' },
  { value: 'HI', label: 'Hawaii' },
  { value: 'ID', label: 'Idaho' },
  { value: 'IL', label: 'Illinois' },
  { value: 'IN', label: 'Indiana' },
  { value: 'IA', label: 'Iowa' },
  { value: 'KS', label: 'Kansas' },
  { value: 'KY', label: 'Kentucky' },
  { value: 'LA', label: 'Louisiana' },
  { value: 'ME', label: 'Maine' },
  { value: 'MD', label: 'Maryland' },
  { value: 'MA', label: 'Massachusetts' },
  { value: 'MI', label: 'Michigan' },
  { value: 'MN', label: 'Minnesota' },
  { value: 'MS', label: 'Mississippi' },
  { value: 'MO', label: 'Missouri' },
  { value: 'MT', label: 'Montana' },
  { value: 'NE', label: 'Nebraska' },
  { value: 'NV', label: 'Nevada' },
  { value: 'NH', label: 'New Hampshire' },
  { value: 'NJ', label: 'New Jersey' },
  { value: 'NM', label: 'New Mexico' },
  { value: 'NY', label: 'New York' },
  { value: 'NC', label: 'North Carolina' },
  { value: 'ND', label: 'North Dakota' },
  { value: 'OH', label: 'Ohio' },
  { value: 'OK', label: 'Oklahoma' },
  { value: 'OR', label: 'Oregon' },
  { value: 'PA', label: 'Pennsylvania' },
  { value: 'RI', label: 'Rhode Island' },
  { value: 'SC', label: 'South Carolina' },
  { value: 'SD', label: 'South Dakota' },
  { value: 'TN', label: 'Tennessee' },
  { value: 'TX', label: 'Texas' },
  { value: 'UT', label: 'Utah' },
  { value: 'VT', label: 'Vermont' },
  { value: 'VA', label: 'Virginia' },
  { value: 'WA', label: 'Washington' },
  { value: 'WV', label: 'West Virginia' },
  { value: 'WI', label: 'Wisconsin' },
  { value: 'WY', label: 'Wyoming' },
];

export const programConfig = [
  {
    Manufacturer: 'Octapharma USA, Inc.',
    Program: 'nuwiq',
    ThemeColor: '#00b597',
    Portal: 'https://nuwiq.medmonk.com',
    HubRole: 'Reimbursement Support',
    HubPhone: '1-800-554-4440',
    HubEmail: 'octapharmasupport@medmonk.com',
    BillingSupportEmail: 'octapharmasupport@medmonk.com',
    BillingSupportPhone: '1-800-554-4440',
  },
  {
    Manufacturer: 'Octapharma USA, Inc.',
    Program: 'wilate',
    ThemeColor: '#f4943f',
    Portal: 'https://wilate.medmonk.com',
    HubRole: 'Reimbursement Support',
    HubPhone: '1-800-554-4440',
    HubEmail: 'octapharmasupport@medmonk.com',
    BillingSupportEmail: 'octapharmasupport@medmonk.com',
    BillingSupportPhone: '1-800-554-4440',
  },
  {
    Manufacturer: 'Octapharma USA, Inc.',
    Program: 'octagam',
    ThemeColor: '#004996',
    Portal: 'https://octagam.medmonk.com',
    HubRole: 'Reimbursement Support',
    HubPhone: '1-800-554-4440',
    HubEmail: 'octapharmasupport@medmonk.com',
    BillingSupportEmail: 'octapharmasupport@medmonk.com',
    BillingSupportPhone: '1-800-554-4440',
  },
  {
    Manufacturer: 'Octapharma USA, Inc.',
    Program: 'cutaquig',
    ThemeColor: '#227586',
    Portal: 'https://cutaquig.medmonk.com',
    HubRole: 'Reimbursement Support',
    HubPhone: '1-800-554-4440',
    HubEmail: 'octapharmasupport@medmonk.com',
    BillingSupportEmail: 'octapharmasupport@medmonk.com',
    BillingSupportPhone: '1-800-554-4440',
  },
  {
    Manufacturer: 'Octapharma USA, Inc.',
    Program: 'panzyga',
    ThemeColor: '#5d2c68',
    Portal: 'https://panzyga.medmonk.com',
    HubRole: 'Reimbursement Support',
    HubPhone: '1-800-554-4440',
    HubEmail: 'octapharmasupport@medmonk.com',
    BillingSupportEmail: 'octapharmasupport@medmonk.com',
    BillingSupportPhone: '1-800-554-4440',
  },
  {
    Manufacturer: 'Octapharma USA, Inc.',
    Program: 'fibryga',
    ThemeColor: '#af0061',
    Portal: 'https://fibryga.medmonk.com',
    HubRole: 'Reimbursement Support',
    HubPhone: '1-800-554-4440',
    HubEmail: 'octapharmasupport@medmonk.com',
    BillingSupportEmail: 'octapharmasupport@medmonk.com',
    BillingSupportPhone: '1-800-554-4440',
  },
  {
    Manufacturer: 'Kedrion Biopharma',
    Program: 'gammaplex',
    ThemeColor: '#45b939',
    Portal: 'https://gammaplex.medmonk.com',
    HubRole: 'Reimbursement Support',
    HubPhone: '1-888-262-8040',
    HubEmail: 'ReimbursementSupport@medmonk.com',
    BillingSupportEmail: 'ReimbursementSupport@medmonk.com',
    BillingSupportPhone: '1-888-262-8040',
    SupportTeamPhone: '1-888-262-8040',
  },
  {
    Manufacturer: 'Kedrion Biopharma',
    Program: 'coagadex',
    ThemeColor: '#004789',
    Portal: 'https://coagadex.medmonk.com',
    HubRole: 'Program Inquiries',
    HubPhone: '1-866-398-0825',
    HubEmail: 'BPLinfo@LashGroup.com',
    BillingSupportEmail: 'support@medmonk.com',
    BillingSupportPhone: '1-866-ADHERE2 (234-3732)',
    SupportTeamPhone: '1-888-262-8040',
  },
  {
    Manufacturer: 'Kedrion Biopharma',
    Program: 'gammaked',
    ThemeColor: '#37afd0',
    Portal: 'https://gammaked.medmonk.com',
    HubRole: 'Reimbursement Support',
    HubPhone: '1-888-262-8040',
    HubEmail: 'ReimbursementSupport@medmonk.com',
    BillingSupportEmail: 'reimbursementsupport@medmonk.com',
    BillingSupportPhone: '1-888-262-8040',
    SupportTeamPhone: '1-888-262-8040',
  },
  {
    Manufacturer: 'Kedrion Biopharma',
    Program: 'koate',
    ThemeColor: '#152763',
    Portal: 'https://koate.medmonk.com/',
    HubRole: 'Program inquiries',
    HubPhone: '1-866-ADHERE2 (234-3732)',
    HubEmail: 'ReimbursementSupport@medmonk.com',
    BillingSupportEmail: 'ReimbursementSupport@medmonk.com',
    BillingSupportPhone: '1-866-ADHERE2 (234-3732)',
    SupportTeamPhone: '1-888-262-8040',
  },
  {
    Manufacturer: 'Kedrion Biopharma',
    Program: 'ryplazim',
    ThemeColor: '#742191',
    Portal: 'https://ryplazim.medmonk.com/',
    HubRole: 'Program inquiries',
    HubPhone: '1-866-ADHERE2 (234-3732)',
    HubEmail: 'ReimbursementSupport@medmonk.com',
    BillingSupportEmail: 'ReimbursementSupport@medmonk.com',
    BillingSupportPhone: '1-866-ADHERE2 (234-3732)',
    SupportTeamPhone: '1-888-262-8040',
  },
  {
    Manufacturer: 'Grifols',
    Program: 'alphanine',
    ThemeColor: '#c4112f',
    Portal: 'https://factorforhealth.medmonk.com',
    HubRole: 'Program inquiries',
    HubPhone: '1-886-234-3732',
    HubEmail: 'support@medmonk.com',
    BillingSupportEmail: 'support@medmonk.com',
    BillingSupportPhone: '1-866-234-3732',
  },
  {
    Manufacturer: 'Grifols',
    Program: 'gamunex',
    ThemeColor: '#00a9a9',
    Portal: 'https://gamunex-c.medmonk.com',
    HubRole: 'Program inquiries',
    HubPhone: '1-888-MY-GAMUNEX (1-888-694-2686)',
    HubEmail: 'support@medmonk.com',
    BillingSupportEmail: 'support@medmonk.com',
    BillingSupportPhone: '1-866-ADHERE2 (234-3732)',
  },
  {
    Manufacturer: 'Grifols',
    Program: 'prolastin',
    ThemeColor: '#0078c1',
    Portal: 'https://prolastin.medmonk.com',
    HubPhone: '1-866-ADHERE2 (234-3732)',
    HubEmail: 'support@medmonk.com',
    BillingSupportEmail: 'support@medmonk.com',
    BillingSupportPhone: '1-866-ADHERE2 (234-3732)',
  },
  {
    Manufacturer: 'Grifols',
    Program: 'xembify',
    ThemeColor: '#034ea1',
    Portal: 'https://xembify.medmonk.com',
    HubRole: 'Program inquiries',
    HubPhone: '1-866-ADHERE2 (234-3732)',
    HubEmail: 'support@medmonk.com',
    BillingSupportEmail: 'support@medmonk.com',
    BillingSupportPhone: '1-866-ADHERE2 (234-3732)',
  },
  {
    Manufacturer: 'GC Biopharma',
    Program: 'alyglo',
    ThemeColor: '#45b939',
    Portal: 'https://alyglo.medmonk.com',
    HubRole: 'Program inquiries',
    HubPhone: '1-888-501-8040',
    HubEmail: 'reimbursementsupport@medmonk.com',
    BillingSupportEmail: 'reimbursementsupport@medmonk.com',
    BillingSupportPhone: '1-888-501-8040',
    SupportTeamPhone: '1-888-501-8040',
  },
];

export const programLabels = {
  alphanine: {
    name: 'ALPHANATE or AlphaNine SD',
    label: 'Factor for Health',
    title:
      'ALPHANATE® (antihemophilic factor/von Willebrand factor complex [human]) and AlphaNine® SD (coagulation factor IX [human])',
    codeUrl: '/Factor-ICD10-Diagnosis-Codes.pdf',
    prescribingLink: '',
  },
  alyglo: {
    name: 'ALYGLO',
    label: 'ALYGLO Copay Assistance',
    title: 'ALYGLO (immune globulin intravenous, human-stwk), 10% Liquid',
    codeUrl: '',
    prescribingLink: '/Alyglo-Prescribing-Information.pdf',
  },
  coagadex: {
    name: 'COAGADEX',
    label: 'COAGADEX Copay Support',
    title: 'COAGADEX (Coagulation Factor X, Human)',
    codeUrl: '',
    prescribingLink: '/Coagadex-Prescribing-Information.pdf',
  },
  cutaquig: {
    name: 'CUTAQUIG',
    label: 'Cutaquig Copay Assistance',
    title: 'Immune Globulin Subcutaneous [Human]-hipp, 16.5% solution',
    codeUrl: '',
    prescribingLink: '',
  },
  fibryga: {
    name: 'FIBRYGA',
    label: 'Fibryga Copay Assistance',
    title: 'Fibrinogen (Human)',
    codeUrl: '',
    prescribingLink: '',
  },
  gammaked: {
    name: 'GAMMAKED',
    label: 'GAMMAKED Copay Assistance',
    title: 'GAMMAKED™ [Immune Globulin Injection (Human) 10% Caprylate/Chromatography Purified]',
    codeUrl: '',
    prescribingLink: '/Gammaked-Prescribing-Information.pdf',
  },
  gammaplex: {
    name: 'GAMMAPLEX',
    label: 'Gammaplex Copay Assistance',
    title: 'Gammaplex 10% (immune globulin intravenous [human], 10%)',
    codeUrl: '',
    prescribingLink: 'http://www.gammaplex.com/prescribing-information',
  },
  gamunex: {
    name: 'GAMUNEX-C',
    label: 'GAMUNEX-C Copay Assistance',
    title: 'GAMUNEX-C (immune globulin injection [human], 10% caprylate/chromatography purified)',
    codeUrl: '/Gamunex-ICD-Diagnosis-Codes.pdf',
    prescribingLink: '/Gamunex-Prescribing-Information.pdf',
  },
  kedrab: {
    name: 'KEDRAB',
    label: 'KEDRAB Copay Assistance',
    title: 'KEDRAB Rabies Immune Globulin (Human)',
    codeUrl: '',
    prescribingLink: '',
  },
  koate: {
    name: 'KOĀTE',
    label: 'KOĀTE Copay Assistance',
    title: 'KOĀTE (Antihemophilic Factor (Human))',
    codeUrl: '',
    prescribingLink: '/KOATE-Prescribing-Information.pdf',
  },
  nuwiq: {
    name: 'NUWIQ',
    label: 'NUWIQ® Copay Assistance',
    title: 'Antihemophilic Factor (Recombinant)',
    codeUrl: '',
    prescribingLink: '',
  },
  octagam: {
    name: 'OCTAGAM',
    label: 'Octagam Copay Assistance',
    title: 'Immune Globulin Intravenous (Human) - Liquid Preparation',
    codeUrl: '',
    prescribingLink: '',
  },
  panzyga: {
    name: 'PANZYGA',
    label: 'PANZYGA Copay Assistance',
    title: 'Immune Globulin Intravenous (Human) - ifas 10% Liquid Preparation',
    codeUrl: '',
    prescribingLink: '',
  },
  prolastin: {
    name: 'PROLASTIN-C LIQUID',
    label: 'PROLASTIN-C Copay Assistance',
    title: 'PROLASTIN-C LIQUID (Alpha1-Proteinase Inhibitor [Human])',
    codeUrl: '/PROLASTIN-ICD10-Diagnosis-Codes.pdf',
    prescribingLink: '/Prolastin-Prescribing-Information.pdf',
  },
  ryplazim: {
    name: 'RYPLAZIM',
    label: 'RYPLAZIM Copay Assistance',
    title: 'RYPLAZIM (plasminogen, human-tvmh)',
    codeUrl: '',
    prescribingLink: '/Ryplazim-Prescribing-Information.pdf',
  },
  wilate: {
    name: 'WILATE',
    label: 'WILATE Copay Assistance',
    title: 'von Willebrand Factor/Coagulation Factor VIII Complex [Human]',
    codeUrl: '',
    prescribingLink: '',
  },
  xembify: {
    name: 'XEMBIFY',
    label: 'XEMBIFY Copay Assistance',
    title: 'XEMBIFY (immune globulin subcutaneous human–klhw)',
    codeUrl: '/Xembify-Diagnosis-Codes.pdf',
    prescribingLink: '/Xembify-Prescribing-Information.pdf',
  },
};
